<!-- style="background-image: url(https://venntur.com/assets/experience/files/{{qualityExperience.mediaExperiences[0].contentUrl}})" -->

<ng-container>
  <!-- Hero Banner Section -->
  <div
    class="hero-banner"
    [ngStyle]="{
      'background-image': 'url(' + getHeroBannerImage(locationObj) + ')'
    }"
  >
    <div class="hero-content">
      <h1>{{ (locationObj?.name || "...").toUpperCase() }}</h1>
      <p class="subtitle">{{ locationObj?.subtitle || "" }}</p>

      <!-- <div class="metrics-bar">
        <div class="metric">
          <span>{{ total || 0 }}</span>
          <p>{{ "Activities" | translate }}</p>
        </div>
        <div class="metric">
          <span>{{ locationObj?.score || "9" }}/10</span>
          <p>{{ "Rank" | translate }}</p>
        </div>
        <div class="metric">
          <span>{{ locationObj?.countReviews || 4267 }}</span>
          <p>{{ "Reviews" | translate }}</p>
        </div>
      </div> -->
    </div>
  </div>

  <!-- Description Section -->
  <div class="container">
    <p class="destination-description">
      {{ locationObj?.description || "No description available..." }}
    </p>
  </div>
  <!-- Top Providers Section -->
  <!-- <section class="top-providers">
    <div class="container">
      <div class="section-header">
        <img src="assets/images/Top Icon.svg" alt="Top Icon" class="top-icon" />
        <h2>{{ "TopProviders" | translate }}</h2>
        <p class="subtitle">
          {{ "providersSubtitle" | translate }} {{ locationObj?.name }}
        </p>
      </div>

      <div class="providers-slider-container">
        <button
          class="keen-slider-prev"
          (click)="providersSlider?.prev()"
          [class.disabled]="currentProvidersSlide === 0"
        >
          <img src="assets/images/arrow-left.svg" alt="Previous" />
        </button>

        <div #providersSliderRef class="keen-slider">
          <div
            class="keen-slider__slide provider-card"
            *ngFor="let provider of activities.slice(0, 4)"
          >
            <a
              [routerLink]="
                '/' + translate.getDefaultLang() + '/maker/' + provider.slug
              "
              target="_blank"
              class="provider-image"
              [ngStyle]="{
                'background-image':
                  'url(' + API_URL + '/' + provider.media[0].contentUrl + ')'
              }"
            >
            </a>
            <div class="provider-info">
              <div class="top-line">
                <a
                  [routerLink]="
                    '/' + translate.getDefaultLang() + '/maker/' + provider.slug
                  "
                  target="_blank"
                  class="provider-name"
                  [title]="provider.name"
                >
                  <h3 class="truncate-text">
                    {{ capitalizeFirstLetter(provider.name) }}
                  </h3>
                </a>
                <div class="rating-container">
                  <img
                    src="assets/images/star.svg"
                    alt="Star Icon"
                    class="star-icon"
                  />
                  <span class="rating">{{ provider.rating }}</span>
                  <span class="rating-label">4.8</span>
                </div>
              </div>
              <div class="bottom-line">
                <p class="location">
                  <img
                    src="assets/images/location.svg"
                    alt="Location Icon"
                    class="location-icon"
                  />
                  {{ locationObj?.name }}
                </p>
              </div>
              <button
                class="discover-more"
                [routerLink]="
                  '/' + translate.getDefaultLang() + '/maker/' + provider.slug
                "
                target="_blank"
              >
                {{ "discover" | translate }}
              </button>
            </div>
          </div>
        </div>

        <button
          class="keen-slider-next"
          (click)="providersSlider?.next()"
          [class.disabled]="
            currentProvidersSlide === providersSliderDotHelper.length - 1
          "
        >
          <img src="assets/images/arrow-right.svg" alt="Next" />
        </button>
      </div>
    </div>
  </section> -->

  <!-- Updated Activities Filter Section -->
  <!-- <div class="container">
    <section class="activities-section">
      <div class="activities-header">
        <h2 class="title">{{ "best" | translate }}{{ locationObj?.name }}</h2>

        <div class="filter-scroll" *ngIf="locationsZones">
          <div class="keen-slider" #lastSliderRef>
            <div class="keen-slider__slide" *ngFor="let zone of locationsZones">
              <div
                class="filter-tag"
                [ngClass]="{ active: filterZone === zone.name }"
                (click)="
                  filterByZone(filterZone === zone.name ? '' : zone.name)
                "
              >
                {{ zone.name }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="activities-slider">
      <div class="keen-slider" #sliderRef>
        <div *ngFor="let activity of activities" class="keen-slider__slide">
          <app-activity-card
            nce-card
            [activity]="activity"
            [isFooterActive]="true"
            class="activity-card"
          ></app-activity-card>
        </div>
      </div>

      <div class="bullets" *ngIf="dotHelper.length > 1">
        <button
          *ngFor="let dot of dotHelper.slice(0, 3); let i = index"
          [ngClass]="i === currentSlide ? 'active' : ''"
          (click)="slider.moveToIdx(i)"
          class="bullet"
        ></button>
      </div>

      <div *ngIf="loading" class="loading-state">
        <div class="spinner-border text-primary" role="status">
          <span class="sr-only">{{ "loading" | translate }}</span>
        </div>
      </div>

      <div *ngIf="activities?.length === 0 && !loading" class="no-results">
        <h2>{{ "No results" | translate }}</h2>
        <p>{{ "No hay experiencias" | translate }}</p>
        <p>
          {{ "Try again in another destination or" | translate }}
          <a href="#">{{ "contact us" | translate }}</a>
          {{
            " and we will help you find the experience you are looking for."
              | translate
          }}
        </p>
      </div>
    </section>
  </div> -->

  <div class="container">
    <div class="col-12">
      <h2>
        <span class="vi-the-best-quality mr-2"></span
        >{{ "allActivities" | translate }}
      </h2>
      <div class="row">
        <div class="col-12">
          <div class="experiences-search">
            <app-experience-search
              [parentVariable]="parentVariable"
              [totalExperiences]="total"
              (parentVariableChange)="changeParentVariable($event)"
            ></app-experience-search>
          </div>
        </div>
      </div>
      <div class="row mb-4" infiniteScroll
      [infiniteScrollDistance]="scrollDistance"
      [infiniteScrollThrottle]="throttle"
      (scrolled)="onScroll()">
        <article
          *ngFor="let activity of activities; let i = index"
          class="activity col-12 col-md-6 col-lg-4 py-4"
        >
          <app-activity-card
            [activity]="activity"
            [isFooterActive]="true"
          ></app-activity-card>
        </article>
      </div>
      <div
        *ngIf="activities && activities.length === 0 && !loading"
        class="col-12 text-center"
      >
        <h2>{{ "Sin resultados" | translate }}</h2>
        <p>
          {{
            "Ups.. Parece que no hay experiencias en este destino. " | translate
          }}
        </p>
        <p>
          {{ "Inténtalo de nuevo en otro destino o" | translate }}
          <a href="#">{{ "ponte en contacto con nosotros" | translate }}</a
          >{{
            " y te ayudaremos a encontrar la experiencia que estás buscando."
              | translate
          }}
        </p>
      </div>
      <div *ngIf="loading" class="text-center loading-container">
        <div class="spinner-border text-primary" role="status">
          <span class="sr-only">{{ "loading" | translate }}</span>
        </div>
      </div>
    </div>
  </div>
</ng-container>
